import Athlete from './Athletes';
import moment from 'moment';
import PaymentData from './PaymentData';
import Meta from './Meta';
import ProductInfo from './ProductInfo';
import FinancingData from './FinancingData';

export default interface Enrollment{
    id: number,
    athlete: Athlete,
    location: string,
    idSportCenter: number,
    size: "6" | "8" | "10" | "12" | "XS" | "S" | "M" | "L" | "XL" | "XXL" | "XXXL" | "XXXXL" | "XXXXXL" | ''
    season: string,
    categoryId: number,
    category: string,
    status: 'active' | 'cancelled' | 'finished' | 'pre' | 'expired' | 'revision' | '',
    enrollDate: any,
    monthEnrollDate: string,
    cancelEnrollDate?: Date,
    paymentData?: PaymentData[],
    isDeliveredMaterial: boolean,
    meta: Meta[],
    productInfo: ProductInfo,
    financingData?: FinancingData[]
}

export const EmptyEnrollment : Enrollment = {
    athlete: {
        birthDate: moment(),
        name: '',
        relationShip: 'myself',
        secondSurname: '',
        registerDate: moment().add(-1, "y"),
        surname: '',
        rfeaCode:'',  
        groups: [],
        personalTrainer:{
            name: '',
            surname: '', 
            secondSurname: '',
            birthDate: moment(),
            dniNie: ''
        }
    },
    categoryId: 0,
    category: '',
    enrollDate: moment(),
    monthEnrollDate: '',
    id: 0,
    location: '',
    idSportCenter: 0,
    season: '',
    size: '',
    status: '',
    isDeliveredMaterial: false,
    meta: [],
    productInfo: {
        active: false,
        description: '',
        features: [],
        fromDate: null,
        gatewayId: '',
        id: 0,
        idCategory: 0,
        initialPay: 0,
        maxDate: null,
        firstPaymentDay: null,
        maxQuotes: 0,
        minQuotes: 0,
        interval: 0,
        intervalCount: 0,
        name: '',
        pvp: 0,
        termsAndConditions:'',
        toDate: null,
        type: '',
        userPayFees: false,
        hash: '',
        idSportCenter: 0
    }
}